<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M35.6845 15.4112C35.6845 15.7256 35.9403 15.9781 36.2553 15.9781C36.5702 15.9781 36.8261 15.7256 36.8261 15.4112V7.63878C36.8261 7.32442 36.5702 7.07187 36.2553 7.07187H22.0685C21.7535 7.07187 21.4977 7.32442 21.4977 7.63878V15.4112C21.4977 15.7256 21.7535 15.9781 22.0685 15.9781C22.3834 15.9781 22.6393 15.7256 22.6393 15.4112V8.20569H35.6845V15.4112Z"
			:fill="props.iconColor"
			:stroke="props.iconColor"
			stroke-width="0.2"
		/>
		<path
			d="M42.7815 26.5245C42.7815 26.8389 43.0374 27.0914 43.3523 27.0914C43.6673 27.0914 43.9231 26.8389 43.9231 26.5245V18.7521C43.9231 18.4377 43.6673 18.1852 43.3523 18.1852H32.5333C32.2183 18.1852 31.9625 18.4377 31.9625 18.7521C31.9625 19.0664 32.2183 19.319 32.5333 19.319H42.7815V26.5245Z"
			:fill="props.iconColor"
			:stroke="props.iconColor"
			stroke-width="0.2"
		/>
		<path
			d="M28.5907 26.5245C28.5907 26.8389 28.8466 27.0914 29.1615 27.0914C29.4765 27.0914 29.7323 26.8389 29.7323 26.5245V18.7521C29.7323 18.4377 29.4765 18.1852 29.1615 18.1852H14.9747C14.6598 18.1852 14.4039 18.4377 14.4039 18.7521V26.5245C14.4039 26.8389 14.6598 27.0914 14.9747 27.0914C15.2897 27.0914 15.5455 26.8389 15.5455 26.5245V19.319H28.5907V26.5245Z"
			:fill="props.iconColor"
			:stroke="props.iconColor"
			stroke-width="0.2"
		/>
		<path
			d="M26.1036 36.2838H32.2178C32.5327 36.2838 32.7886 36.0313 32.7886 35.7169C32.7886 35.4025 32.5327 35.15 32.2178 35.15H26.1036C25.7887 35.15 25.5328 35.4025 25.5328 35.7169C25.5328 36.0313 25.7887 36.2838 26.1036 36.2838Z"
			:fill="props.iconColor"
			:stroke="props.iconColor"
			stroke-width="0.2"
		/>
		<path
			d="M45.9568 35.72C45.9568 36.0343 46.2127 36.2869 46.5276 36.2869C46.8426 36.2869 47.0984 36.0343 47.0984 35.72V29.8712C47.0984 29.5568 46.8426 29.3043 46.5276 29.3043H11.795C11.4801 29.3043 11.2242 29.5568 11.2242 29.8712V35.72C11.2242 36.0343 11.4801 36.2869 11.795 36.2869C12.11 36.2869 12.3658 36.0343 12.3658 35.72V30.4381H45.9568V35.72Z"
			:fill="props.iconColor"
			:stroke="props.iconColor"
			stroke-width="0.2"
		/>
		<path
			d="M14.4039 38.1832C14.4039 40.801 16.5492 42.9274 19.1868 42.9274C21.8244 42.9274 23.9697 40.801 23.9697 38.1832C23.9697 35.5655 21.8244 33.4391 19.1868 33.4391C16.5492 33.4391 14.4039 35.5655 14.4039 38.1832ZM15.5455 38.1801C15.5455 36.1911 17.1791 34.5698 19.1868 34.5698C21.1945 34.5698 22.8281 36.1911 22.8281 38.1801C22.8281 40.1692 21.1945 41.7905 19.1868 41.7905C17.1791 41.7905 15.5455 40.1692 15.5455 38.1801Z"
			:fill="props.iconColor"
			:stroke="props.iconColor"
			stroke-width="0.2"
		/>
		<path
			d="M34.357 38.1832C34.357 40.801 36.5024 42.9274 39.1399 42.9274C41.7775 42.9274 43.9228 40.801 43.9228 38.1832C43.9228 35.5655 41.7775 33.4391 39.1399 33.4391C36.5024 33.4391 34.357 35.5655 34.357 38.1832ZM35.4986 38.1801C35.4986 36.1911 37.1323 34.5698 39.1399 34.5698C41.1476 34.5698 42.7812 36.1911 42.7812 38.1801C42.7812 40.1692 41.1476 41.7905 39.1399 41.7905C37.1323 41.7905 35.4986 40.1692 35.4986 38.1801Z"
			:fill="props.iconColor"
			:stroke="props.iconColor"
			stroke-width="0.2"
		/>
		<path
			d="M8.17459 15.021C8.10579 14.7784 7.88105 14.609 7.62641 14.609H3.4708C3.15585 14.609 2.9 14.8615 2.9 15.1759C2.9 15.4903 3.15585 15.7428 3.4708 15.7428H7.19306L10.3014 26.679L11.0026 27.0693C11.0023 27.0694 11.002 27.0694 11.0017 27.0695M8.17459 15.021L8.07838 15.0483L8.17458 15.0209L8.17459 15.021ZM8.17459 15.021L11.398 26.3699L11.3982 26.3705C11.4819 26.6723 11.3068 26.9863 11.0017 27.0695M11.0017 27.0695C10.9513 27.0837 10.9025 27.0914 10.8498 27.0917M11.0017 27.0695L10.8498 27.0917M10.8498 27.0917V27.0917H10.8467L10.8498 27.0917Z"
			:fill="props.iconColor"
			:stroke="props.iconColor"
			stroke-width="0.2"
		/>
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 50,
		height: 50,
		iconColor: '#ffffff',
	}
);
</script>

<style lang="scss" scoped></style>
